/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.modal-title[_ngcontent-%COMP%]{cursor:move}h5[_ngcontent-%COMP%]{margin-left:10px;width:100%}"];
export { styles as styles };
